import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0006',
    ecrans: ['00-2'],
    params: ['id',
            '?prucleint',
            '?vaesysnatctb',
            '?peccleintdeb',
            '?peccleintfin',
            '?indcleint']
});
